import { Box } from '@/shared/ui/box';
import { SkeletonLoader } from '@/shared/ui/skeleton';
import { BonusList } from '@/flat-pages/bonuses/ui/styles';
import { BonusItemSkeleton } from './styles';

export const BonusSkeleton = () => {
  return (
    <>
      <Box
        $margin="12px 0 32px 0"
        $display="flex"
        $flexDirection="column"
        $alignItems="center"
        $gap="16px"
      >
        <Box $flex="1" $width="220px">
          <SkeletonLoader height={45} />
        </Box>
      </Box>
      <BonusList>
        {[1, 2, 3, 4].map((el) => (
          <BonusItemSkeleton key={el}>
            <SkeletonLoader width="100%" height="510px" />
          </BonusItemSkeleton>
        ))}
      </BonusList>
    </>
  );
};
